import { useQuery } from '@tanstack/react-query';
import { paymentApis } from '../api/paymentApi';

export const usePackages = () => {
  return useQuery({
    queryKey: ['packages'],
    queryFn: () => paymentApis.getPackages(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
